import React from 'react';

import styled from 'styled-components';

import { useBuilderConstructorCategoryNav } from '~/builder/utils/useBuilderConstructorCategoryNav';
import { slugify } from '~/techstyle-shared/react-components';
import { FormattedMessage } from '~/techstyle-shared/react-intl';

import useBuilderConstructorGridInputs from '../../hooks/useBuilderConstructorGridInputs';

import DesktopSideNavCategoryTree from './DesktopSideNavCategoryTree';

const DynamicFormattedMessage = FormattedMessage;

const SideNavWrapper = styled.div`
  margin-bottom: 2rem;
  display: flex;
  flex-direction: column;
`;

const SideNavHeading = styled.h2`
  font-weight: 600;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.gridSideNavHeaderTextColor};
  margin-bottom: 1rem;
`;

const DesktopSideNav = () => {
  const { sideNav, builderModel } = useBuilderConstructorGridInputs();

  // This is outdated and based on the legacy navigationizer. Pages may be broken as they do not always exist in builder.
  const clientCategoryNavSettings = useBuilderConstructorCategoryNav({
    sideNav,
    builderModel,
  });

  const activeCategory = clientCategoryNavSettings?.activeCategory;
  const categoryHeading = activeCategory?.isTopLevel
    ? activeCategory?.label
    : activeCategory?.ancestors?.[0]?.label;

  if (!sideNav?.shouldShowCategoryNav || !activeCategory) {
    return null;
  }

  return (
    <SideNavWrapper>
      {sideNav?.shouldShowCategoryHeading && categoryHeading && (
        <SideNavHeading>
          <DynamicFormattedMessage
            id={`site_product_category.${slugify(categoryHeading)}`}
            defaultMessage={categoryHeading}
          />
        </SideNavHeading>
      )}
      <DesktopSideNavCategoryTree activeCategory={activeCategory} />
    </SideNavWrapper>
  );
};

export default DesktopSideNav;
